<div class="call-assign-container">
  <div class="call-assign-card">
    <div class="card-header">
      <h3>Asignación de taxi</h3>
      <ion-button fill="outline" size="small" class="edit-button">
        <ion-icon name="pencil-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
    <div class="card-content">
      <div class="assign-placeholder">
        <p>Funcionalidad de asignación en desarrollo...</p>
        <p>Aquí se mostrarán las opciones para asignar un taxi al viaje.</p>
      </div>
    </div>
  </div>
</div>